/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  today: 'Dzisiaj',
  now: 'Teraz',
  backToToday: 'Ustaw dzisiaj',
  ok: 'Ok',
  clear: 'WyczyÅÄ',
  month: 'MiesiÄc',
  year: 'Rok',
  timeSelect: 'Ustaw czas',
  dateSelect: 'Ustaw datÄ',
  monthSelect: 'Wybierz miesiÄc',
  yearSelect: 'Wybierz rok',
  decadeSelect: 'Wybierz dekadÄ',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Poprzedni miesiÄc (PageUp)',
  nextMonth: 'NastÄpny miesiÄc (PageDown)',
  previousYear: 'Ostatni rok (Ctrl + left)',
  nextYear: 'NastÄpny rok (Ctrl + right)',
  previousDecade: 'Ostatnia dekada',
  nextDecade: 'NastÄpna dekada',
  previousCentury: 'Ostatni wiek',
  nextCentury: 'NastÄpny wiek'
};
